import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { tracker } from '../analytics/tracker';
import { useFeatureFlags } from './useFeatureFlags';

export function useTrackFeatureFlags() {
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    const formattedObject = Object.fromEntries(
      Object.entries(featureFlags).map(([key, value]) => [
        `rm.flag_${key}`,
        value,
      ])
    );

    void tracker.identify({
      myrm_user_parameters: JSON.stringify(formattedObject),
    });

    Sentry.setTags(formattedObject);
  }, [featureFlags]);
}
